import React from 'react';
import moment from 'moment';
import { Progress, Segment, Popup } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { Event } from 'legacy/common/types/models';

interface EventPreviewProps {
  event: Event;
  onClick: () => void;
}

const EventPreview: React.FC<EventPreviewProps> = ({ event, onClick }) => {
  const { t } = useTranslation('events');
  
  let dateLabel = '';
  if (event.startDate) {
    dateLabel = moment(event.startDate).format('YYYY-MM-DD');
  }

  const imageStyles = {};

  if (!event.photo.url) {
    Object.assign(imageStyles, {
      backgroundSize: '40px',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundColor: '#F0F3FF'
    });
  }

  return (
    <Segment key={event._id} className="event" onClick={onClick}>
      <Progress
        attached="top"
        percent={
          event.maxAttendance
            ? (event.totalGuests / event.maxAttendance) * 100
            : 0
        }
        warning={event.status === 'min'}
        success={event.status === 'bounced'}
        error={event.status === 'max'}
      />
      <div className="wrapper">
        <div className="abs-content">
          {event.isDraft && (
            <div className="absolute top-1/2 left-1/2 z-50 text-gray-600 text-3xl font-bold transform -translate-x-3/4 -translate-y-1/2 rotate-45 opacity-50 pointer-events-none">
              {t('eventPreview.draft')}
            </div>
          )}

          <div
            className="pic"
            style={{
              backgroundImage:
                event.photo && event.photo.url
                  ? `url(${event.photo.url})`
                  : 'url(/img/events/portrait-cover.svg)',
              backgroundSize: 'cover',
              ...imageStyles
            }}
          >
            {event.userHostStatus === 'operator' && ( // @deprecated -- very brittle, can't really touch this bit without breaking something
              <Popup
                position="right center"
                trigger={<i className="operator-icon fa fa-user-cog" />}
                content={t('eventPreview.operatorTooltip')}
              />
            )}
          </div>

          <div className="info">
            <div className="title">
              {event.title || (event.isDraft && t('eventPreview.draftEventNoTitle'))}
            </div>
            <div className="time">{dateLabel}</div>
            {(event.isOrganizer || event.showGuests) && (
              <div className="attendance">
                <span>{event.totalGuests}</span>
                {event.maxAttendance
                  ? `/${event.maxAttendance} ${t('eventPreview.going')}`
                  : ` ${t('eventPreview.going')}`} 
              </div>
            )}
          </div>
        </div>
      </div>
    </Segment>
  );
};

export default EventPreview;
